export const SUBSCRIBE_TO_NEWSLETTER_URL = process.env.SUBSCRIBE_TO_NEWSLETTER_URL
export const SITE_URL = process.env.SITE_URL
